<template>
    <div id="dashboard-page" style="margin-bottom:55px;">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/company">Company</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <b-form class="mt-3 mx-2">
                <b-row>
                    <b-col md="6">
                        <!--<b-row>
                            <b-col md="4"><label class="labels">Status</label></b-col>
                            <b-col md="8"><p><b-badge :variant="getStatusColor(model.status)">{{getStatusName(model.status)}}</b-badge></p></b-col>
                        </b-row>-->
                        <!--<b-row>
                            <b-col md="4"><label class="labels">ID Company</label></b-col>
                            <b-col md="8"><p>{{ model.code !== null ? model.code : '-' }}</p></b-col>
                        </b-row>-->
                        <b-row>
                          <b-col md="4"><label class="labels">Name</label></b-col>
                          <b-col md="8"><p>{{ model.name !== '' ? model.name : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Business Sector</label></b-col>
                          <b-col md="8"><p>{{ model.businessSector !== '' ? model.businessSector : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Registration ID</label></b-col>
                          <b-col md="8"><p>{{ model.registrationId !== null ? model.registrationId : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Headquarters Address</label></b-col>
                          <b-col md="8"><p class="text-justify">{{ model.address !== '' ? model.address : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Email</label></b-col>
                          <b-col md="8"><p>{{ model.email !== '' ? model.email : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Telephone</label></b-col>
                          <b-col md="8"><p>{{ model.phone }}</p></b-col>
                          <!-- <b-col md="8"><p>{{ model.phone }} {{ model.extPhone === '' ? '' : '- ' + model.extPhone }}</p></b-col> -->
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Tax ID</label></b-col>
                          <b-col md="8"><p>{{ model.taxId !== null ? model.taxId : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Fax</label></b-col>
                          <b-col md="8"><p>{{ model.fax !== null ? model.fax : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Status Office</label></b-col>
                          <b-col md="8"><p><b-badge :variant="getStatusColor(model.isHq)">{{getStatusName(model.isHq)}}</b-badge></p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">About Company</label></b-col>
                          <b-col md="8"><p class="text-justify">{{ model.about !== null && model.about !== '' ? model.about : '-' }}</p></b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <div class="photo-box">
                                    <b-row v-if="model.path === null || model.path === 'null' || model.path === ''">
                                        <b-col md="12 mb-4 text-center">
                                            <p class="text-secondary text-center border border-radius p-5 ml-0 mt-1" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                                        </b-col>
                                        <!-- <b-col md="2 mt-4">
                                            <b-button variant="primary" class="btn-custom" @click="showModal()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                        </b-col> -->
                                    </b-row>
                                    <viewer v-else>
                                        <b-row>
                                            <b-col md="12 mb-4 text-center">
                                                <b-img :src="model.path" class="img-responsive text-center mt-0 ml-0" style="border-radius: 20px!important; width:340px!important;height: 200px!important;"/>
                                            </b-col>
                                        </b-row>
                                    </viewer>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-form>
            <b-button class="mt-3" :to="'/company-structure/company'" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button class="mt-3 float-right" :to="'/company-structure/company/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>
        </b-card>
    </div>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)
    
    export default {
        name: 'company-details',
        data () {
            return {
                isLoading: false,
                apiUrl: {
                    company: window.AppConfig.apiUrl + 'company'
                },
                model: {
                    code: '',
                    status: '',
                    name: '',
                    address: '',
                    phone: '',
                    path: null,
                    extPhone: '',
                    registrationId: '',
                    taxId: '',
                    businessSector:'',
                    fax: '',
                    email: '',
                    about: '',
                    isHq: '',
                    // isActive: true,
                }
            }
        },
        mounted () {
            this.getDetail()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.company + '/' + this.$route.params.uuid).then(response => {
                  this.model.code = response.data.code !== null ? response.data.code : '-'
                  this.model.status = response.data.status !== '' ? response.data.status : '-'
                  this.model.name = response.data.name !== '' ? response.data.name : '-'
                  this.model.businessSector = response.data.businessSector !== null ? response.data.businessSector.name : '-'
                  this.model.path = response.data.path
                  this.model.address = response.data.address !== '' ? response.data.address : '-'
                  this.model.registrationId = response.data.registrationId !== null ? response.data.registrationId : '-'
                  this.model.taxId = response.data.taxId !== null ? response.data.taxId : '-'
                  this.model.phone = response.data.phone !== null ? response.data.phone : '-'
                  this.model.extPhone = response.data.extPhone !== null ? response.data.extPhone : '-'
                  this.model.fax = response.data.fax !== null ? response.data.fax : '-'
                  this.model.email = response.data.email !== '' ? response.data.email : '-'
                  this.model.about = response.data.about !== '' ? response.data.about : '-'
                  this.model.isHq = response.data.isHq === '1' ? true : false
                //   this.model.isActive = response.data.isActive !== null ? response.data.isActive : '-'
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                if (val) {
                    return "secondary"
                } else {
                    return "success"
                }
            },
            getStatusName (val) {
                if (val) {
                    return "Company"
                } else {
                    return "Headquarters"
                }
            }
        }
    }
</script>